export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13924.e7abfe59.jpg";